import React from "react";

export default function Bar({ className }) {
  return (
    <>
      <svg
        width="4"
        height="50"
        viewBox="0 0 4 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_251_2239)">
          <rect width="4" height="112" fill="currentColor" />
          <rect
            width="4"
            height="50"
            transform="translate(0 -4)"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_251_2239">
            <rect width="4" height="50" fill="red" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
